// src/hooks/useUpdateUserProfile.ts
import { useState } from 'react';
import { Contact } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useDeleteContactToCustomer = () => {
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  const deleteContactToCustomer = async (contactId: number) => {
    const token = sessionState.account?.token;
    if (!token) {
      setError('Login or token is missing');
      return false;
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/contact/${contactId}`, {
        method: 'DELETE',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });

      if (!response.ok) {
        throw new Error('Failed to delete contact');
      }

      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return false;
    }
  };

  return { deleteContactToCustomer, error };
};

export default useDeleteContactToCustomer;
